import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableBoolean, nullableNumber, nullableString } from '../utils/wire-value-utils';
import { SafetyTestFrequency } from './safety-test-frequency.model';

/**
 * A safety-test category as `/admin/safety-test-categories` returns it (hub `data-models/safety-test-category.ts`).
 * System-wide categories have `organizationId = null`. A writable field the hub didn't send stays `undefined`.
 */
export class SafetyTestCategory extends Base {
  // Writable via PUT /admin/safety-test-categories/:id (the hub's SAFETY_TEST_CATEGORY_WRITABLE)
  name?: string | null;
  shortName?: string | null;
  description?: string | null;
  icon?: string | null;
  isRequired?: boolean | null;
  frequency?: SafetyTestFrequency | null;
  frequencyDays?: number | null;
  sortOrder?: number | null;

  // Read-only (set on create)
  organizationId?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.name = nullableString(source['name']);
    this.shortName = nullableString(source['shortName']);
    this.description = nullableString(source['description']);
    this.icon = nullableString(source['icon']);
    this.isRequired = nullableBoolean(source['isRequired']);
    this.frequency = nullableString(source['frequency']) as SafetyTestFrequency | null | undefined;
    this.frequencyDays = nullableNumber(source['frequencyDays']);
    this.sortOrder = nullableNumber(source['sortOrder']);
    this.organizationId = nullableString(source['organizationId']);
  }
}
